import { render, staticRenderFns } from "./MyDatabaseTable.vue?vue&type=template&id=0954209a"
import script from "./MyDatabaseTable.vue?vue&type=script&lang=js"
export * from "./MyDatabaseTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports